module.exports = __webpack_public_path__ + "img/ko.4d7928d0.svg";